import { useEffect, useState } from 'react';
import { env } from 'Shared/constants/env';

export type AdyenDropin = {
  submit(): void;
  events: {
    isValid(): boolean;
  };
};

export type AdyenCheckout = {
  create(type: string): {
    mount(htmlId: string): AdyenDropin;
  };
};

export const translations = {
  'en-US': {
    'creditCard.expiryDateField.title': 'Expiration date',
    'error.va.sf-cc-dat.01': 'Enter a valid expiration date',
    'error.va.sf-cc-dat.02': 'Enter a valid expiration date',
    'error.va.sf-cc-dat.04': 'Enter the expiration date',
    'error.va.sf-cc-dat.05': 'Enter the complete expiration date',
    'error.va.sf-cc-mth.01': 'Enter the expiration month',
    'error.va.sf-cc-yr.01': 'Enter the expiration year',
    'error.va.sf-cc-yr.02': 'Enter the complete expiration year',
    'creditCard.encryptedExpiryDate.aria.label': 'Expiration date',
    'creditCard.encryptedExpiryMonth.aria.label': 'Expiration month',
    'creditCard.encryptedExpiryYear.aria.label': 'Expiration year',
  },
};

export const useAdyenScripts = () => {
  const [scriptLoaded, setScriptLoaded] = useState(false);

  useEffect(() => {
    // Load and inject Adyen CSS.
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = `https://checkoutshopper-${env.adyenEnv}.adyen.com/checkoutshopper/sdk/${env.adyenVersion}/adyen.css`;
    link.integrity = env.adyenCssHash;
    link.crossOrigin = 'anonymous';
    document.head.appendChild(link);

    // Load and inject Adyen SDK asynchronously.
    const script = document.createElement('script');
    script.src = `https://checkoutshopper-${env.adyenEnv}.adyen.com/checkoutshopper/sdk/${env.adyenVersion}/adyen.js`;
    script.integrity = env.adyenScriptHash;
    script.async = true;
    script.crossOrigin = 'anonymous';
    script.onload = () => setScriptLoaded(true);
    document.body.appendChild(script);

    return () => {
      script.remove(); // Remove script from the DOM on exit.
      link.remove();
    };
  }, []);

  return { environment: env.adyenEnv, scriptLoaded };
};
